import { render } from "./KalaSearch.vue?vue&type=template&id=b2830b58&scoped=true"
import script from "./KalaSearch.vue?vue&type=script&lang=js"
export * from "./KalaSearch.vue?vue&type=script&lang=js"

import "./KalaSearch.vue?vue&type=style&index=0&id=b2830b58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2830b58"]])

export default __exports__